import React from 'react';
import { Flex, Typography } from 'antd';
import classes from './ActionButton.module.css';

type ActionButtonProps = {
  text: string;
  prefix?: React.ReactNode;
  image?: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: () => unknown;
  id?: string;
};

const ActionButton: React.FC<ActionButtonProps> = ({
  text,
  prefix,
  image,
  icon,
  onClick,
  id
}) => {
  return (
    <Flex flex={1} id={id} vertical gap={10} className={classes.wrapper} justify="space-between" onClick={onClick}>
      {image && (
        <span>{image}</span>
      )}
      <Flex flex={1} justify="space-between">
        <Flex>
          {prefix &&
            <div style={{ marginRight: 12 }}>{prefix}</div>
          }
          <Typography.Text className={classes.text}>{text}</Typography.Text>
        </Flex>
        {icon}
      </Flex>
    </Flex>
  );
};

export default ActionButton;
